import React from "react";
import { Routes, Route } from "react-router-dom";

import IndexPage from "./pages/Index.js";
import ContactPage from "./pages/contact.js";
import TOSPage from "./pages/tos.js";
import PrivacyPage from "./pages/privacy.js";
import LegalPage from "./pages/legal.js";

function App() {
  return (
    <Routes>
      <Route path="/" element={<IndexPage />} />
      <Route path="/contact" element={<ContactPage />} />
      <Route path="/terms" element={<TOSPage />} />
      <Route path="/legal" element={<LegalPage />} />
      <Route path="/privacy" element={<PrivacyPage />} />
    </Routes>
  );
}

export default App;
